module.exports = __webpack_public_path__ + "img/title2.6af119f4.png";